import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SInvoiceDetailsPageContentButtons = styled.div`
  margin-top: 20px;
  gap: 15px;

  ${setFlexDFAIC};
`;
